import { ItemService } from '@services/item.service';
export default class Adapter {
  loader;
  reader;
  config;
  allowedFileTypes: string[] = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
  constructor(loader, config, public itemservice: ItemService,) {
    this.loader = loader;
    this.config = config;
  }


  public async upload(): Promise<any> {
    let file = await this.loader.file;
    const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
    if (fileSizeInMB > 100) {
      sessionStorage.setItem('ImageUploadFileSizeErr', 'true');
      sessionStorage.setItem('imageUploadErr', 'false');
      // this.itemservice.imageSizeErr.next(true);
      return Promise.reject('');
      // return Promise.reject('Exceeded maximum file size of 100 MB');
    } else {
      sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    }

    if (!this.allowedFileTypes.includes(file.type)) {
      sessionStorage.setItem('imageUploadErr', 'true');
      sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
      // this.itemservice.imageUploadErr.next(true);
      return Promise.reject('');
    } else {
      sessionStorage.setItem('imageUploadErr', 'false');
    }
    // return this.read(file);
    return Promise.resolve(this.read(file))
  }

  read(file) {
    // console.log(file);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function () {
        resolve({ default: reader.result, fileName: file.name });
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.onabort = function () {
        reject();
      };
      reader.readAsDataURL(file);
    });
  }

  abort() {
    if (this.reader) {
      this.reader.abort();
    }
  }
}

